import { render, staticRenderFns } from "./CartBar.vue?vue&type=template&id=5a1545db&scoped=true"
import script from "./CartBar.vue?vue&type=script&lang=js"
export * from "./CartBar.vue?vue&type=script&lang=js"
import style0 from "./CartBar.vue?vue&type=style&index=0&id=5a1545db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1545db",
  null
  
)

export default component.exports